import { useState, useEffect } from 'react'

// Global state outside the hook to keep all timers synchronized
let globalTimeLeft = 643 // 10 minutes 43 seconds
let listeners: React.Dispatch<React.SetStateAction<number>>[] = []
let intervalId: NodeJS.Timeout | null = null

const startGlobalTimer = () => {
  if (!intervalId) {
    intervalId = setInterval(() => {
      globalTimeLeft -= 1
      if (globalTimeLeft <= 0) {
        globalTimeLeft = 0
        if (intervalId) clearInterval(intervalId)
      }
      listeners.forEach((listener) => listener(globalTimeLeft))
    }, 1000)
  }
}

export const useCountdown = () => {
  const [timeLeft, setTimeLeft] = useState(globalTimeLeft)

  useEffect(() => {
    listeners.push(setTimeLeft)
    startGlobalTimer()

    return () => {
      listeners = listeners.filter((l) => l !== setTimeLeft)
    }
  }, [])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60

  return {
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
    isZero: timeLeft === 0,
  }
}
